import { render, staticRenderFns } from "./YcSettingsHint.vue?vue&type=template&id=5bc834a9&scoped=true"
import script from "./YcSettingsHint.vue?vue&type=script&lang=js"
export * from "./YcSettingsHint.vue?vue&type=script&lang=js"
import style0 from "./YcSettingsHint.vue?vue&type=style&index=0&id=5bc834a9&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc834a9",
  null
  
)

export default component.exports